import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-film-line text-xl text-accent-400"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">
                光棍影院
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-md">
              专注最新电影与电视剧的内容门户，为你提供剧情介绍、多维筛选与个性化推荐，让每一次找片更轻松、更愉快。
            </p>
            <p className="text-xs text-background-400 mt-4 max-w-md leading-relaxed">
              本站所有影视信息、评分与图片均为演示示例内容，不含真实播放接口，仅供产品体验与展示使用。
            </p>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-background-50 mb-4">快速导航</h2>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-background-300 hover:text-accent-400 transition-colors">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-background-300 hover:text-accent-400 transition-colors">
                  电视剧分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-300 hover:text-accent-400 transition-colors">
                  搜索影视
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-background-50 mb-4">帮助与支持</h2>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li>
                <Link to="/about" className="text-background-300 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-background-300 hover:text-accent-400 transition-colors">
                  常见问题
                </Link>
              </li>
              <li className="text-background-300">客服邮箱：support@ggfilm.example.com</li>
              <li className="text-background-300">服务时间：每日 09:00 - 22:00</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 光棍影院 · 保留所有权利
          </p>
          <p className="text-xs text-background-400">
            隐私条款 · 免责声明 · 内容均为演示示例
          </p>
        </div>
      </div>
    </footer>
  );
}